/**
 * Preserve the desktop viewport across Shopify's native newsletter POST.
 *
 * A customer form posts to `/contact#contact_form`; the fragment makes the
 * browser jump to the footer when Shopify reloads the page with its server-
 * rendered success state. We keep Shopify's form, validation, CAPTCHA and
 * success/error response untouched. The submitting viewport is stored for one
 * short-lived navigation and restored only when the success status exists.
 */
(() => {
  const form = document.querySelector('[data-tcs-newsletter-position]');
  if (!(form instanceof HTMLFormElement)) return;

  const storageKey = 'tcs:newsletter-position';
  const maxAge = 60_000;
  const path = window.location.pathname;
  const cleanUrl = `${window.location.pathname}${window.location.search}`;

  const takePosition = () => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      sessionStorage.removeItem(storageKey);
      if (!raw) return null;

      const value = JSON.parse(raw);
      if (value.path !== path || Date.now() - value.savedAt > maxAge) return null;
      return value;
    } catch {
      return null;
    }
  };

  const saved = takePosition();
  const success = form.querySelector('.tcs-footer__newsletter-message[role="status"]');

  if (saved && success) {
    if (window.location.hash === '#contact_form') {
      history.replaceState(history.state, '', cleanUrl);
    }

    const restore = () => window.scrollTo(saved.x, saved.y);
    restore();
    requestAnimationFrame(() => requestAnimationFrame(restore));
    window.addEventListener('pageshow', restore, { once: true });

    // A server-rendered live region is not consistently announced. Reinsert
    // its existing text without moving focus or changing the viewport.
    const message = success.textContent;
    success.textContent = '';
    requestAnimationFrame(() => {
      success.textContent = message;
    });
  }

  form.addEventListener('submit', () => {
    if (!window.matchMedia('(min-width: 990px)').matches || !form.checkValidity()) return;

    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          path,
          x: window.scrollX,
          y: window.scrollY,
          savedAt: Date.now(),
        }),
      );
    } catch {
      // Storage can be disabled. The native Shopify submission still works.
    }
  });
})();
